<span
[class.tooltip-wrapper]="!isDownloadButtonEnabled"
[attr.data-title]="
  isDownloadButtonEnabled
    ? ''
    : 'You do not have permission to download a copy of this publication. Please contact your PM to request access.'
"
>
<button
  *ngIf="isDownloadButtonVisible"
  (click)="onDownloadClick($event)"
  [ngClass]="{ 'btn-xs': fromDocumentSearch }"
  class="flex flex-row items-center btn btn-primary"
  [id]="'btn-download-' + index"
  [disabled]="!isDownloadButtonEnabled"
>
  <span class="mr-1 material-symbols-rounded icon-16">download</span>
  Download&nbsp;
</button>
</span>

